import { createUniqueId } from '@/utils/createId'
import state from './state'
import mutations from './mutations'
import actionsFactory from './actions'

const actions = actionsFactory({
  createUniqueId,
})

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
